import Vue from 'vue'
import VueRouter from 'vue-router'
import PageLogin from 'components/pages/PageLogin'
import PageOrderDetails from 'components/pages/PageOrderDetails'
import PageSearch from 'components/pages/PageSearch'
import PageOrderList from 'components/pages/PageOrderList'

import Store from './Store.js'

Vue.use(VueRouter)

export const backButtonRoutes = {
  'search': '/',
  'search-result': '/',
  'order-details': '/'
}

/* eslint-disable no-new */
const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      components: {
        default: PageOrderList,
        search: PageSearch
      },
      name: 'order-list',
      meta: {
        title: 'Liste des commandes'
      }
    },
    {
      path: '/connexion',
      component: PageLogin,
      name: 'login',
      title: 'Login'
    },
    {
      path: '/commande/:id',
      component: PageOrderDetails,
      name: 'order-details',
      meta: {
        title: 'Commande détails'
      }
    },
    {
      path: '/rechercher',
      component: PageSearch,
      name: 'search',
      meta: {
        title: 'Rechercher une commande'
      }
    },
    {
      path: '/resultat-recherche',
      components: {
        default: PageOrderList,
        search: PageSearch
      },
      name: 'order-list',
      meta: {
        title: 'Résultat de recherche'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /*
    Add route class to the body
  */
  document.body.className = to.name

  /*
    Navigation guard. Redirects the user to the login page if not logged-in
  */
  if (to.name !== 'login' && (!Store.state.authToken || Store.state.authToken === 'null')) {
    next({name: 'login'})
  }
  else {
    next()
  }
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/Router.js